<ion-menu side="start" content-id="menuContent" [class]="menuCssClass" *ngIf="menuIsEnabled">
	<ion-header class="ion-no-border">
		<!-- <ion-searchbar class="ion-no-padding" showCancelButton="always" placeholder=""></ion-searchbar> -->

		<ion-segment
			value="{{ visibilityTypeEnum.HideArchived }}"
			mode="ios"
			(ionChange)="toggleArchivedVisibility($event)"
		>
			<ion-segment-button value="{{ visibilityTypeEnum.HideArchived }}">
				<ion-label>{{ 'burgerMenu.segments.hideArchived' | translate }}</ion-label>
			</ion-segment-button>
			<ion-segment-button value="{{ visibilityTypeEnum.ShowArchived }}">
				<ion-label>{{ 'burgerMenu.segments.showArchived' | translate }}</ion-label>
			</ion-segment-button>
		</ion-segment>
	</ion-header>
	<ion-content>
		<ion-list
			*ngFor="let workfile of workfiles"
			[class.workfile-selected]="workfile.workFileId === currentWorkspaceId && !currentProjectNumber"
		>
			<ion-grid class="ion-no-padding">
				<ion-row>
					<ion-col size="8" class="ion-no-padding ion-no-margin" (click)="selectWorkFile(workfile)">
						<ion-label
							*ngIf="workfile.archived && !workfile.pendingDelete"
							class="workfile-archived ion-no-padding ion-no-margin"
							>{{ 'burgerMenu.labels.archived' | translate }}</ion-label
						>
						<ion-label
							*ngIf="workfile.archived && workfile.pendingDelete"
							class="workfile-archived ion-no-padding ion-no-margin"
							>{{ 'burgerMenu.labels.pendingDelete' | translate }}</ion-label
						>
						<ion-menu-toggle>
							<ion-item
								lines="none"
								class="ion-no-padding"
								detail="false"
								button
								*ngIf="workfile.projects?.length > 0"
							>
								<ion-icon
									*ngIf="workfile.archived && !workfile.pendingDelete"
									class="workfile-archived icon-Archived"
								></ion-icon>
								<ion-icon
									*ngIf="workfile.archived && workfile.pendingDelete"
									class="workfile-archived workfile-pending-delete icon-Warning"
								></ion-icon>
								<ion-label class="ion-no-padding ion-no-margin">{{ workfile.workspaceName }}</ion-label>
							</ion-item>
						</ion-menu-toggle>
					</ion-col>
					<ion-col
						size="2"
						class="ion-no-padding ion-no-margin icons"
						(click)="workfile.isExpanded = !workfile.isExpanded"
					>
						<ion-label
							*ngIf="workfile.archived"
							class="workfile-archived ion-no-padding ion-no-margin"
						></ion-label>

						<ion-icon
							*ngIf="!workfile.isExpanded && !workfile.pendingDelete"
							class="icon-Expand"
						></ion-icon>
						<ion-icon
							*ngIf="workfile.isExpanded && !workfile.pendingDelete"
							class="icon-Collapse"
						></ion-icon>
					</ion-col>
					<ion-col
						size="2"
						class="ion-no-padding ion-no-margin icons"
						(click)="deleteWorkFile(workfile.workFileId)"
					>
						<ion-label
							*ngIf="workfile.archived"
							class="workfile-archived ion-no-padding ion-no-margin"
						></ion-label>

						<ion-icon class="icon-Delete"></ion-icon>
					</ion-col>
				</ion-row>
			</ion-grid>
			<ion-list *ngIf="workfile.isExpanded && !workfile.pendingDelete" class="no-padding">
				<ion-menu-toggle *ngFor="let project of workfile.projects">
					<ion-item
						lines="none"
						class="ion-no-padding"
						data-cy="projectName"
						(click)="selectProject(workfile.workFileId, project.project_number)"
						[class.project-selected]="
							workfile.workFileId === currentWorkspaceId &&
							project.project_number === currentProjectNumber
						"
						detail="false"
					>
						<ion-icon name="ellipse-outline"></ion-icon>
						<ion-label>{{ project.project_number }}</ion-label>
					</ion-item>
				</ion-menu-toggle>
			</ion-list>
		</ion-list>
	</ion-content>
	<ion-footer class="ion-no-border">
		<ion-grid>
			<ion-row>
				<ion-menu-toggle class="ion-margin-bottom" auto-hide="true" (click)="importWorkfile()">
					<ion-icon name="add-outline"></ion-icon>
					{{ 'burgerMenu.buttons.importWorkfile.label' | translate }}
				</ion-menu-toggle>
			</ion-row>
			<ion-row>
				<ion-menu-toggle class="ion-margin-bottom" auto-hide="true" (click)="appendWorkfile()">
					<ion-icon name="add-outline"></ion-icon>
					{{ 'burgerMenu.buttons.appendNewData.label' | translate }}
				</ion-menu-toggle>
			</ion-row>
			<!-- <ion-row>
				<input
				type="file"
				accept="application/JSON"
				(change)="appendFile($event)"
				style="display: none;"
				#fileInput
				/>
				<ion-menu-toggle auto-hide="true" (click)="fileInput.click()">
				<ion-icon name="add-outline"></ion-icon>
				{{ 'burgerMenu.buttons.appendNewData.label' | translate }}
				</ion-menu-toggle>
			</ion-row> -->
		</ion-grid>
	</ion-footer>
</ion-menu>
